import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import * as Actions from '../actions/ProductManagement';

const GetProductListReducer = handleActions({
    [Actions.getProductsByCompanyRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.getProductsByCompanyReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        success: true,
    }),
    [Actions.getProductsByCompanyReceiveFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
        success: false,
    }),
    [Actions.getProductsByCompanyClear]: () => ({
        isFetching: false,
        data: {},
        errors: {},
        success: undefined,
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
    success: undefined,
});

const GetProductInfoReducer = handleActions({
    [Actions.getProductInfoRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.getProductInfoReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        success: true,
    }),
    [Actions.getProductInfoReceiveFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
        success: false,
    }),
    [Actions.getProductInfoClear]: () => ({
        isFetching: false,
        data: {},
        errors: {},
        success: undefined,
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
    success: undefined,
});

const CreateProductReducer = handleActions({
    [Actions.createProductRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.createProductReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        success: true,
    }),
    [Actions.createProductReceiveFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
        success: false,
    }),
    [Actions.createProductProgess]: (state, action) => ({
        ...state,
        percent: action.payload,
    }),
    [Actions.createProductClear]: () => ({
        isFetching: false,
        data: {},
        errors: {},
        success: undefined,
        percent: 0,
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
    success: undefined,
    percent: 0,
});

const UpdateProductReducer = handleActions({
    [Actions.updateProductRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.updateProductReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        success: true,
    }),
    [Actions.updateProductReceiveFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
        success: false,
    }),
    [Actions.updateProductClear]: () => ({
        isFetching: false,
        data: {},
        errors: {},
        success: undefined,
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
    success: undefined,
});

const DeleteProductReducer = handleActions({
    [Actions.deleteProductRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.deleteProductReceived]: (state) => ({
        ...state,
        isFetching: false,
        success: true,
    }),
    [Actions.deleteProductReceiveFailure]: (state, action) => ({
        isFetching: false,
        errors: action.payload.errors,
        success: false,
    }),
    [Actions.deleteProductClear]: () => ({
        isFetching: false,
        errors: {},
        success: undefined,
    }),
}, {
    isFetching: false,
    errors: {},
    success: undefined,
});

const UpdateProductOrderReducer = handleActions({
    [Actions.updateProductOrderRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.updateProductOrderReceived]: (state) => ({
        ...state,
        isFetching: false,
        success: true,
    }),
    [Actions.updateProductReceiveFailure]: (state, action) => ({
        isFetching: false,
        errors: action.payload.errors,
        success: false,
    }),
    [Actions.clearUpdateProductOrder]: () => ({
        isFetching: false,
        errors: {},
        success: false,
    }),
}, {
    isFetching: false,
    errors: {},
    success: false,
});

export default combineReducers({
    getList: GetProductListReducer,
    getProduct: GetProductInfoReducer,
    create: CreateProductReducer,
    update: UpdateProductReducer,
    delete: DeleteProductReducer,
    productOrder: UpdateProductOrderReducer,
});
